import { Component } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import storageService from "@shared/storage/storageService";
import { ConfigService } from "./app-config.service";

@Component({
  selector: "body",
  template: ` <router-outlet></router-outlet> <app-redirect></app-redirect> `,
})
export class AppComponent {
  
  DEFAULT_LANGUAGE = "fr";

  constructor(
    private configService: ConfigService,
    private router: Router,
    private translate: TranslateService
  )
  {
    // storageService.clearAll();
    this.setupLanguage();
    this.getNotificationOptions();
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
        if (!(event instanceof NavigationEnd)) {
            return;
        }
        window.scrollTo(0, 0)
    });
  }
  /**
   * Sets up default language for the application. Uses browser default language.
   */
  public setupLanguage(): void {
    // Implemented this feature on landing page
    try {
      this.translate.addLangs(['en', 'fr']);
      if(storageService.getItem("language")) {
        this.DEFAULT_LANGUAGE = storageService.getItem("language");
      }else{
        storageService.setItem("language", this.DEFAULT_LANGUAGE);
      }
      this.translate.setDefaultLang(this.DEFAULT_LANGUAGE);
      this.translate.use(this.DEFAULT_LANGUAGE);
    } catch (error) {
      console.error("Error while setting default language, ", error);
    }
  }

  /**
   * Returns global notification options
   */
  public getNotificationOptions(): any {
    return this.configService.get("notifications").options;
  }
}
